import { render, staticRenderFns } from "./InspectionsHistory.vue?vue&type=template&id=b8e78c6a"
import script from "./InspectionsHistory.vue?vue&type=script&lang=js"
export * from "./InspectionsHistory.vue?vue&type=script&lang=js"
import style0 from "./InspectionsHistory.vue?vue&type=style&index=0&id=b8e78c6a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports